import React, { useEffect, useState } from 'react';
import { MdOutlineInfo } from "react-icons/md";
import { BiLogoTelegram } from "react-icons/bi";
import BlurChart from "../../assets/blur-chart.webp";
import { BiSolidHourglass } from "react-icons/bi";
import './HoldersTime.css';

const Clock = BiSolidHourglass  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
const TG = BiLogoTelegram  as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

interface ProjectInfoProps {
  ca: any;
}

export interface ChartData {
  tracking_buys: boolean;
  tracking_sells: boolean;
  tracking_total_transactions_h1: boolean;
  total_transactions_h1: number;
  total_transactions_trend: string;
  total_transactions_percentage_change_normalized: number;
  tracking: boolean;

  sells_h1: number;
  sells_trend: string;
  sells_percentage_change_normalized: number;

  buys_h1: number;
  buys_trend: string;
  buys_percentage_change_normalized: number;
}

const HoldersTime: React.FC<ProjectInfoProps> = ({ ca }) => {
  const [data, setData] = useState<ChartData>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(`https://aen226grpxvqujgu7zid7k6qsq0xwuui.lambda-url.us-east-1.on.aws/?id=${ca}`);
        if (!res.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await res.json();
        setData(data);
      } catch (err: any) {
        console.error(err.message);
      }
    };

    if (ca) {
      fetchData();
    }
  }, [ca]);

  return (
    <div className="social-embed">
      <div className='chart-frames'>
          {data && data.tracking_total_transactions_h1 === false ? (
            <>
              <div className="telegram-smaller-box">
                <div className="chart-title">
                  Tx per hour <div className={`badge-tg ${data.total_transactions_trend}`}>{data.total_transactions_trend}</div>
                </div>
                <div className='telegram-amounts'>
                  <div className='tg-amount'>{data.total_transactions_h1.toLocaleString('en-US')}</div>
                <div
                    className="perc-change"
                    style={{
                      color: data.total_transactions_percentage_change_normalized > 0
                        ? 'rgb(14,203,129)'
                        : data.total_transactions_percentage_change_normalized < 0
                          ? 'rgb(246,70,93)'
                          : 'grey'
                    }}                  >
                    {data.total_transactions_percentage_change_normalized >= 0 ? "+" : ""}{data.total_transactions_percentage_change_normalized?.toFixed(2)}%
                  </div>
                </div>
              </div>
              <iframe src={`https://i73nm2ep37yf2x75fdcrsr6hou0xwioz.lambda-url.us-east-1.on.aws/${ca}/total_transactions_h1`}></iframe>
            </>
            ) :
            (
              <>
                <div className="telegram-smaller-box">
                  <div className="chart-title">
                    Transactions per hour
                  </div>
                  <div className='telegram-amounts'>
                    <div className='tg-amount' style={{fontSize: '12px', lineHeight: '24px'}}>Not available yet...</div>
                  </div>
                </div>
                <div className="chart-unavailable">
                  <img className='blur-chart' src={BlurChart}></img>
                  <div className='na-text'><Clock /> Tracking data...</div>
                </div>
              </>
            )
          }
      </div>
      <div className='chart-frames'>
          {data && data.tracking_buys === false ? (
            <>
              <div className="telegram-smaller-box">
                <div className="chart-title">
                  Buys per hour <div className={`badge-tg ${data.buys_trend}`}>{data.buys_trend}</div>
                </div>
                <div className='telegram-amounts'>
                  <div className='tg-amount'>{data.buys_h1.toLocaleString('en-US')}</div>
                <div
                    className="perc-change"
                    style={{
                      color: data.buys_percentage_change_normalized > 0
                        ? 'rgb(14,203,129)'
                        : data.buys_percentage_change_normalized < 0
                          ? 'rgb(246,70,93)'
                          : 'grey'
                    }}                  >
                    {data.buys_percentage_change_normalized >= 0 ? "+" : ""}{data.buys_percentage_change_normalized?.toFixed(2)}%
                  </div>
                </div>
              </div>
              <iframe src={`https://i73nm2ep37yf2x75fdcrsr6hou0xwioz.lambda-url.us-east-1.on.aws/${ca}/buys_h1`}></iframe>
            </>
            ) :
            (
              <>
                <div className="telegram-smaller-box">
                  <div className="chart-title">
                    Buys per hour
                  </div>
                  <div className='telegram-amounts'>
                    <div className='tg-amount' style={{fontSize: '12px', lineHeight: '24px'}}>Not available yet...</div>
                  </div>
                </div>
                <div className="chart-unavailable">
                  <img className='blur-chart' src={BlurChart}></img>
                  <div className='na-text'><Clock /> Tracking data...</div>
                </div>
              </>
            )
          }
      </div>
      <div className='chart-frames'>
          {data && data.tracking_sells === false ? (
            <>
              <div className="telegram-smaller-box">
                <div className="chart-title">
                  Sells per hour <div className={`badge-tg ${data.sells_trend === 'decreasing' ? 'increasing' : data.sells_trend === 'increasing' ? 'decreasing' : 'stable'}`}>{data.sells_trend}</div>
                </div>
                <div className='telegram-amounts'>
                  <div className='tg-amount'>{data.sells_h1.toLocaleString('en-US')}</div>
                <div
                    className="perc-change"
                    style={{
                      color: data.sells_percentage_change_normalized < 0
                        ? 'rgb(14,203,129)'
                        : data.sells_percentage_change_normalized > 0
                          ? 'rgb(246,70,93)'
                          : 'grey'
                    }}                  >
                    {data.sells_percentage_change_normalized >= 0 ? "+" : ""}{data.sells_percentage_change_normalized?.toFixed(2)}%
                  </div>
                </div>
              </div>
              <iframe src={`https://i73nm2ep37yf2x75fdcrsr6hou0xwioz.lambda-url.us-east-1.on.aws/${ca}/sells_h1`}></iframe>
            </>
            ) :
            (
              <>
                <div className="telegram-smaller-box">
                  <div className="chart-title">
                    Sells per hour
                  </div>
                  <div className='telegram-amounts'>
                    <div className='tg-amount' style={{fontSize: '12px', lineHeight: '24px'}}>Not available yet...</div>
                  </div>
                </div>
                <div className="chart-unavailable">
                  <img className='blur-chart' src={BlurChart}></img>
                  <div className='na-text'><Clock /> Tracking data...</div>
                </div>
              </>
            )
          }
      </div>
    </div>
  );
};

export default HoldersTime;
